import React from "react";
import { SITE_CONTENT } from "../content";
import { Link } from "react-router-dom";
import fishBg from "../assets/bg.jpg";

const tagColors = {
  "Food Culture": { bg: "#f5c518", color: "#1a1a1a" },
  "Our Values": { bg: "#006400", color: "#fff" },
  "Expansion News": { bg: "#cd3a27", color: "#fff" },
};

const BlogSection = () => {
  const { blog } = SITE_CONTENT.sections;

  return (
    <section
      id="blog"
      className="py-20 bg-fixed bg-center bg-cover relative overflow-hidden"
      style={{
        backgroundImage: `url(${fishBg})`,
        boxShadow: "0 0 0 1px #0a1a0f",
      }}
    >
      <div className="absolute inset-0 bg-[#0a1a0f]/85"></div>

      {/* Top Zigzag */}
      <div
        className="absolute top-0 left-0 w-full h-[12px] bg-repeat-x z-10"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 12'%3E%3Cpath d='M0 0l12 12 12-12' fill='%23ffffff'/%3E%3C/svg%3E\")",
          backgroundSize: "24px 12px",
        }}
      />

      <div className="relative z-20 max-w-7xl mx-auto px-4 md:px-8">
        {/* Title */}
        <div className="text-center mb-14">
          <span
            style={{
              display: "block",
              fontFamily: "Raleway, sans-serif",
              fontSize: "10px",
              fontWeight: 700,
              letterSpacing: "4px",
              textTransform: "uppercase",
              color: "#f5c518",
              marginBottom: "10px",
            }}
          >
            {blog.eyebrow}
          </span>
          <h2 className="text-5xl md:text-6xl font-['Dancing_Script'] text-[#cd3a27] font-medium leading-none drop-shadow-md">
            {blog.title}
          </h2>
          {/* Ornamental Divider */}
          <div className="flex items-center justify-center gap-3 mt-4">
            <div className="h-[1.5px] w-16 bg-gradient-to-r from-transparent via-[#cd3a27] to-[#cd3a27]"></div>
            <div className="w-2.5 h-2.5 border border-[#cd3a27] rotate-45 flex items-center justify-center">
              <div className="w-1 h-1 bg-[#cd3a27]"></div>
            </div>
            <div className="h-[1.5px] w-16 bg-gradient-to-l from-transparent via-[#cd3a27] to-[#cd3a27]"></div>
          </div>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blog.posts.map((post) => {
            const tagStyle = tagColors[post.tag] || {
              bg: "#555",
              color: "#fff",
            };
            return (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="bg-white flex flex-col group shadow-lg hover:-translate-y-2 transition-transform duration-300 no-underline"
                style={{ textDecoration: "none" }}
              >
                {/* Color top bar */}
                <div
                  style={{
                    background: tagStyle.bg,
                    height: "5px",
                    width: "100%",
                  }}
                />

                {/* Cover image */}
                <div
                  style={{
                    width: "100%",
                    height: "200px",
                    overflow: "hidden",
                    background: "#0d0d0d",
                    position: "relative",
                  }}
                >
                  <img
                    src={post.coverImage}
                    alt={post.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                      transition: "transform 0.5s ease",
                      display: "block",
                    }}
                    className="group-hover:scale-110"
                  />
                  {/* Dark overlay on hover */}
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: "rgba(0,0,0,0.25)",
                      transition: "opacity 0.3s",
                    }}
                    className="group-hover:opacity-0"
                  />
                </div>

                {/* Content Body */}
                <div className="flex-1 flex flex-col p-7">
                  {/* Tag pill */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "12px",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        background: tagStyle.bg,
                        color: tagStyle.color,
                        fontSize: "9px",
                        fontWeight: 700,
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        padding: "4px 10px",
                        borderRadius: "3px",
                      }}
                    >
                      {post.tag}
                    </span>
                    <span
                      style={{
                        fontSize: "10px",
                        color: "#888",
                        fontFamily: "Raleway, sans-serif",
                        fontWeight: 600,
                        letterSpacing: "0.5px",
                      }}
                    >
                      ⏱ {post.readTime}
                    </span>
                  </div>

                  <h3
                    className="font-bold text-[17px] text-gray-900 mb-3 group-hover:text-[#cd3a27] transition-colors leading-snug"
                    style={{ fontFamily: "Raleway, sans-serif" }}
                  >
                    {post.title}
                  </h3>

                  {/* Red Dash */}
                  <div className="w-8 h-[2px] bg-[#cd3a27] mb-4"></div>

                  <p className="text-[13px] text-gray-500 leading-relaxed mb-4 flex-1">
                    {post.excerpt.slice(0, 130)}...
                  </p>

                  <span
                    style={{
                      display: "inline-block",
                      color: "#cd3a27",
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                      fontFamily: "Raleway, sans-serif",
                      marginBottom: "16px",
                    }}
                  >
                    Read Full Article →
                  </span>

                  {/* Meta block */}
                  <div className="w-full pt-4 border-t border-gray-100 flex items-center justify-between text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                    <span>{post.date}</span>
                    <span className="text-[#cd3a27]">{post.author}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Bottom Zigzag */}
      <div
        className="absolute bottom-0 left-0 w-full h-[12px] bg-repeat-x z-10"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 12'%3E%3Cpath d='M0 12L12 0l12 12' fill='%23ffffff'/%3E%3C/svg%3E\")",
          backgroundSize: "24px 12px",
        }}
      />
    </section>
  );
};

export default BlogSection;
